import { Outlet } from "react-router";
import { Sidebar } from "./sidebar";
import { Toaster } from "./toaster";

export function Layout() {
  return (
    <div className="flex h-screen bg-canvas text-ink">
      <Sidebar />
      <main className="min-w-0 flex-1 overflow-y-auto">
        <div className="flex flex-col gap-[18px] px-8 py-7">
          <Outlet />
        </div>
      </main>
      <Toaster />
    </div>
  );
}
